import { useEffect, useState } from "react";
import { getLoadingState, subscribeToLoading } from "./loading-store";

const useGlobalLoader = () => {
  const [state, setState] = useState(getLoadingState());

  useEffect(() => {
    const unsubscribe = subscribeToLoading(setState);
    return () => unsubscribe();
  }, []);

  return state;
};

export default useGlobalLoader;
